export const SORT_BY_DISTANCE = 'sortByDistance';
export const SORT_BY_NEWEST = 'createdAt';
